import { LIMITS } from 'js/config/consts';
import {
  ColorLayer,
  ColorTab,
  ColorType,
  DirectionType,
  ElementType,
  ExistingScribeModel,
  HideEventTrigger,
  ImageCategory,
  UpgradeButtonClickExtraEventProps,
  TemplatePreview,
  TextAlignValue,
  UploadProvider,
  UserPersonaAnswers,
  AccountType,
  AccountTerm,
  VSLibrarySourceType,
  ImageSource
} from 'js/types';

export const TRACK_PERSONA_ANSWERS = 'TRACK_PERSONA_ANSWERS';
export const SAVE_PARTIAL_PERSONA_ANSWERS = 'SAVE_PARTIAL_PERSONA_ANSWERS';
export const TRACK_OPEN_ACCOUNT_MANAGEMENT = 'TRACK_OPEN_ACCOUNT_MANAGEMENT';
export const TRACK_CLICK_CHANGE_SUBSCRIPTION_TERM_BUTTON = 'TRACK_CLICK_CHANGE_SUBSCRIPTION_TERM_BUTTON';
export const TRACK_TEMPLATE_PREVIEW_CLICK = 'TRACK_TEMPLATE_PREVIEW_CLICK';
export const LEAVE_TEMPLATE_PREVIEW = 'LEAVE_TEMPLATE_PREVIEW';
export const TRACK_TEMPLATE_SCROLL = 'TRACK_TEMPLATE_SCROLL';
export const TRACK_TEMPLATE_EDIT = 'TRACK_TEMPLATE_EDIT';
export const TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE = 'TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE';
export const TRACK_IMAGE_IMPORT_CLICK = 'TRACK_IMAGE_IMPORT_CLICK';
export const TRACK_IMAGE_LIBRARY_CLICK = 'TRACK_IMAGE_LIBRARY_CLICK';
export const TRACK_IMAGE_PROVIDER_CHANGE = 'TRACK_IMAGE_PROVIDER_CHANGE';
export const TRACK_IMAGE_SEARCH = 'TRACK_IMAGE_SEARCH';
export const TRACK_OPEN_DOWNLOAD = 'TRACK_OPEN_DOWNLOAD';
export const TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS = 'TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS';
export const TRACK_AUDIO_RECORDING_CANCEL = 'TRACK_AUDIO_RECORDING_CANCEL';
export const TRACK_PLAY_SCRIBE = 'TRACK_PLAY_SCRIBE';
export const TRACK_OPEN_SCRIBE = 'TRACK_OPEN_SCRIBE';
export const TRACK_FREE_TRANSFORM_SELECTED = 'TRACK_FREE_TRANSFORM_SELECTED';
export const TRACK_FLIP_ELEMENT = 'TRACK_FLIP_ELEMENT';
export const TRACK_SELECT_FONT = 'TRACK_SELECT_FONT';
export const TRACK_ALIGN_TEXT = 'TRACK_ALIGN_TEXT';
export const TRACK_BOLD_TEXT = 'TRACK_BOLD_TEXT';
export const TRACK_ITALIC_TEXT = 'TRACK_ITALIC_TEXT';
export const TRACK_CHANGE_ELEMENT_COLOR = 'TRACK_CHANGE_ELEMENT_COLOR';
export const TRACK_DOWNLOAD_PROGRESS_HIDDEN = 'TRACK_DOWNLOAD_PROGRESS_HIDDEN';
export const TRACK_FULLSCREEN_ENTERED = 'TRACK_FULLSCREEN_ENTERED';
export const TRACK_SELECT_ALL = 'TRACK_SELECT_ALL';
export const TRACK_SHARE_PROJECT = 'TRACK_SHARE_PROJECT';
export const TRACK_PREVIEW_LINK_COPY = 'TRACK_PREVIEW_LINK_COPY';
export const TRACK_IMAGE_REPLACE_MODAL = 'TRACK_IMAGE_REPLACE_MODAL';
export const TRACK_IMAGE_REPLACE = 'TRACK_IMAGE_REPLACE';
export const TRACK_SET_ACTIVE_ELEMENTS_VISIBILITY = 'TRACK_SET_ACTIVE_ELEMENTS_VISIBILITY';
export const TRACK_SEARCH_BY_PROJECT_TITLE = 'TRACK_SEARCH_BY_PROJECT_TITLE';
export const TRACK_CREATE_NEW_PROJECT = 'TRACK_CREATE_NEW_PROJECT';
export const TRACK_TIMELINE_ZOOM_EXPANDED = 'TRACK_TIMELINE_ZOOM_EXPANDED';
export const TRACK_TIMELINE_SCROLL_TO_BEGINNING = 'TRACK_TIMELINE_SCROLL_TO_BEGINNING';
export const TRACK_TIMELINE_SCROLL_TO_END = 'TRACK_TIMELINE_SCROLL_TO_END';
export const TRACK_OPEN_RECORD_AUDIO_MODAL = 'TRACK_OPEN_RECORD_AUDIO_MODAL';
export const TRACK_OPEN_UPLOAD_AUDIO_MODAL = 'TRACK_OPEN_UPLOAD_AUDIO_MODAL';
export const TRACK_PREVIEW_AUDIO = 'TRACK_PREVIEW_AUDIO';
export const TRACK_SEARCH_AUDIO_FILES = 'TRACK_SEARCH_AUDIO_FILES';
export const TRACK_SELECT_FILTER_AUDIO_FILES = 'TRACK_SELECT_FILTER_AUDIO_FILES';
export const TRACK_FILTER_TEMPLATES_BY_CATEGORY = 'TRACK_FILTER_TEMPLATES_BY_CATEGORY';
export const TRACK_CAMERA_WARNING_MODAL = 'TRACK_CAMERA_WARNING_MODAL';
export const TRACK_DOWNLOAD_BLOCKED_BY_PREMIUM_CONTENT = 'TRACK_DOWNLOAD_BLOCKED_BY_PREMIUM_CONTENT';
export const TRACK_UPGRADE_SUBSCRIPTION_BUTTON_CLICKED = 'TRACK_UPGRADE_SUBSCRIPTION_BUTTON_CLICKED';
export const TRACK_PURCHASE_SUBSCRIPTION_BUTTON_CLICKED = 'TRACK_PURCHASE_SUBSCRIPTION_BUTTON_CLICKED';
export const TRACK_HIT_USAGE_LIMIT = 'TRACK_HIT_USAGE_LIMIT';
export const TRACK_HIT_PROJECT_DURATION_LIMIT = 'TRACK_HIT_PROJECT_DURATION_LIMIT';
export const TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED = 'TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED';
export const TRACK_NO_ACCESS_FEATURE_MODAL_DISPLAYED = 'TRACK_NO_ACCESS_FEATURE_MODAL_DISPLAYED';
export const TRACK_SPLIT_AUDIO_TRACK = 'TRACK_SPLIT_AUDIO_TRACK';
export const TRACK_AUDIO_SPLIT_MODE_CANCEL = 'TRACK_AUDIO_SPLIT_MODE_CANCEL';
export const TRACK_CLICK_ENABLE_COLOUR_CHANGE_ON_IMAGE = 'TRACK_CLICK_ENABLE_COLOUR_CHANGE_ON_IMAGE';
export const TRACK_ENABLE_COLOUR_CHANGE_INFO_MODAL_DISPLAYED = 'TRACK_ENABLE_COLOUR_CHANGE_INFO_MODAL_DISPLAYED';
export const TRACK_CONFIRM_COLOUR_CHANGE_ON_IMAGE = 'TRACK_CONFIRM_COLOUR_CHANGE_ON_IMAGE';
export const TRACK_IMAGE_COLOUR_CHANGE_SUCCESSFUL = 'TRACK_IMAGE_COLOUR_CHANGE_SUCCESSFUL';
export const TRACK_WORD_SELECTED_IN_TRANSCRIPT_PANEL = 'TRACK_WORD_SELECTED_IN_TRANSCRIPT_PANEL';
export const TRACK_CLICK_ASSETS_TAB = 'TRACK_CLICK_ASSETS_TAB';
export const TRACK_CLICK_ASSETS_IMAGES_TAB = 'TRACK_CLICK_ASSETS_IMAGES_TAB';
export const TRACK_RENAME_IMAGE_ASSET = 'TRACK_RENAME_IMAGE_ASSET';
export const TRACK_DELETE_IMAGE_ASSET = 'TRACK_DELETE_IMAGE_ASSET';
export const TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE = 'TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE';

export interface TrackClickEnableColourChangeOnImageAction {
  type: typeof TRACK_CLICK_ENABLE_COLOUR_CHANGE_ON_IMAGE;
  scribeId: number;
}
export const trackClickEnableColourChangeOnImage = (scribeId: number): TrackClickEnableColourChangeOnImageAction => ({
  type: TRACK_CLICK_ENABLE_COLOUR_CHANGE_ON_IMAGE,
  scribeId
});

export interface TrackEnableColourChangeInfoModalDisplayedAction {
  type: typeof TRACK_ENABLE_COLOUR_CHANGE_INFO_MODAL_DISPLAYED;
  scribeId: number;
}
export const trackEnableColourChangeInfoModalDisplayed = (
  scribeId: number
): TrackEnableColourChangeInfoModalDisplayedAction => ({
  type: TRACK_ENABLE_COLOUR_CHANGE_INFO_MODAL_DISPLAYED,
  scribeId
});

export interface TrackConfirmColourChangeOnImageAction {
  type: typeof TRACK_CONFIRM_COLOUR_CHANGE_ON_IMAGE;
  scribeId: number;
}
export const trackConfirmColourChangeOnImage = (scribeId: number): TrackConfirmColourChangeOnImageAction => ({
  type: TRACK_CONFIRM_COLOUR_CHANGE_ON_IMAGE,
  scribeId
});

interface TrackImageColourChangeSuccessfulAction {
  type: typeof TRACK_IMAGE_COLOUR_CHANGE_SUCCESSFUL;
  scribeId: number;
}
export const trackImageColourChangeSuccessful = (scribeId: number): TrackImageColourChangeSuccessfulAction => ({
  type: TRACK_IMAGE_COLOUR_CHANGE_SUCCESSFUL,
  scribeId
});

export interface TrackHitUsageLimitAction {
  type: typeof TRACK_HIT_USAGE_LIMIT;
  limit: LIMITS;
  scribeId?: number;
}

export const trackHitUsageLimit = (limit: LIMITS, scribeId?: number): TrackHitUsageLimitAction => ({
  type: TRACK_HIT_USAGE_LIMIT,
  scribeId,
  limit
});

export interface TrackHitProjectDurationLimitAction {
  type: typeof TRACK_HIT_PROJECT_DURATION_LIMIT;
  scribeId: number;
}

export const trackHitProjectDurationLimit = (scribeId: number): TrackHitProjectDurationLimitAction => ({
  type: TRACK_HIT_PROJECT_DURATION_LIMIT,
  scribeId
});

export interface TrackHitProjectDurationLimitModalDisplayedAction {
  type: typeof TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED;
  scribeId: number;
}

export const trackHitProjectDurationLimitModalDisplayed = (
  scribeId: number
): TrackHitProjectDurationLimitModalDisplayedAction => ({
  type: TRACK_HIT_PROJECT_DURATION_LIMIT_MODAL_DISPLAYED,
  scribeId
});

interface TrackPersonalAnswersAction {
  type: typeof TRACK_PERSONA_ANSWERS;
  answers: UserPersonaAnswers;
  date: Date;
  userTriggered: boolean;
}

export const trackPersonaAnswers = (
  answers: UserPersonaAnswers,
  date: Date,
  userTriggered = false
): TrackPersonalAnswersAction => ({
  type: TRACK_PERSONA_ANSWERS,
  answers,
  date,
  userTriggered
});

interface SavePartialPersonaAnswersAction {
  type: typeof SAVE_PARTIAL_PERSONA_ANSWERS;
  answers: Partial<UserPersonaAnswers>;
  date: Date;
}

export const savePartialPersonaAnswers = (
  answers: Partial<UserPersonaAnswers>,
  date: Date
): SavePartialPersonaAnswersAction => ({
  type: SAVE_PARTIAL_PERSONA_ANSWERS,
  answers,
  date
});

export const trackOpenAccountManagement = () => ({ type: TRACK_OPEN_ACCOUNT_MANAGEMENT });
export const trackClickChangeSubscriptionTermButton = () => ({ type: TRACK_CLICK_CHANGE_SUBSCRIPTION_TERM_BUTTON });
export const trackAudioRecordingCancel = () => ({ type: TRACK_AUDIO_RECORDING_CANCEL });

export interface TrackTemplatePreviewClickAction {
  type: typeof TRACK_TEMPLATE_PREVIEW_CLICK;
  template: TemplatePreview;
  category: string;
}

export const trackTemplatePreviewClick = (
  template: TemplatePreview,
  category: string
): TrackTemplatePreviewClickAction => ({
  type: TRACK_TEMPLATE_PREVIEW_CLICK,
  template,
  category
});

export interface LeaveTemplatePreviewAction {
  type: typeof LEAVE_TEMPLATE_PREVIEW;
}

export const leaveTemplatePreview = (): LeaveTemplatePreviewAction => ({
  type: LEAVE_TEMPLATE_PREVIEW
});

export interface TrackTemplateScrollAction {
  type: typeof TRACK_TEMPLATE_SCROLL;
  category: string;
}

export const trackTemplateScroll = (category: string): TrackTemplateScrollAction => ({
  type: TRACK_TEMPLATE_SCROLL,
  category
});

interface TrackTemplateEditAction {
  type: typeof TRACK_TEMPLATE_EDIT;
  title: string;
  category: string;
  triggerLocation: string;
  sparkolTemplateId: string;
}

export const trackTemplateEdit = (
  title: string,
  category: string,
  triggerLocation: string,
  sparkolTemplateId: string
): TrackTemplateEditAction => ({
  type: TRACK_TEMPLATE_EDIT,
  title,
  category,
  triggerLocation,
  sparkolTemplateId
});

export interface TrackDownloadFormatSelectionChangeAction {
  type: typeof TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE;
  format: string;
  scribe: ExistingScribeModel;
}

export const trackDownloadFormatSelectionChange = (
  format: string,
  scribe: ExistingScribeModel
): TrackDownloadFormatSelectionChangeAction => ({
  type: TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE,
  format,
  scribe
});

export interface TrackImageImportClickAction {
  type: typeof TRACK_IMAGE_IMPORT_CLICK;
  scribeId: number;
}

export const trackImageImportClick = (scribeId: number): TrackImageImportClickAction => ({
  type: TRACK_IMAGE_IMPORT_CLICK,
  scribeId
});

export interface TrackImageLibraryClickAction {
  type: typeof TRACK_IMAGE_LIBRARY_CLICK;
  library: ImageCategory;
  scribeId: number;
  trigger?: TrackImageLibraryClickActionTrigger;
}
export type TrackImageLibraryClickActionTrigger = 'Category Index' | 'Category Carousel';
export const trackImageLibraryClick = (
  library: ImageCategory,
  scribeId: number,
  trigger?: TrackImageLibraryClickActionTrigger
): TrackImageLibraryClickAction => ({
  type: TRACK_IMAGE_LIBRARY_CLICK,
  library,
  scribeId,
  trigger
});

export interface TrackImageProviderChangeAction {
  type: typeof TRACK_IMAGE_PROVIDER_CHANGE;
  provider: UploadProvider;
  libraryState: 'search' | 'category';
  tab: ImageSource;
}

export const trackImageProviderChange = (
  provider: UploadProvider,
  libraryState: 'search' | 'category',
  tab: ImageSource
): TrackImageProviderChangeAction => ({
  type: TRACK_IMAGE_PROVIDER_CHANGE,
  provider,
  libraryState,
  tab
});

export interface TrackImageSearchAction {
  type: typeof TRACK_IMAGE_SEARCH;
  query: string;
  scribeId: number;
  tab: ImageSource;
}

export const trackImageSearch = (query: string, scribeId: number, tab: ImageSource): TrackImageSearchAction => ({
  type: TRACK_IMAGE_SEARCH,
  query,
  scribeId,
  tab
});

export interface TrackOpenDownloadAction {
  type: typeof TRACK_OPEN_DOWNLOAD;
  scribeId: number;
}

export const trackOpenDownload = (scribeId: number): TrackOpenDownloadAction => ({
  type: TRACK_OPEN_DOWNLOAD,
  scribeId
});

export interface TrackUpdateScribeBackgroundSettingsAction {
  type: typeof TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS;
  scribeId: number;
  colorType?: ColorType;
}

export const trackUpdateScribeBackgroundSettings = (
  scribeId: number,
  colorType: ColorType
): TrackUpdateScribeBackgroundSettingsAction => ({
  type: TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS,
  scribeId,
  colorType
});

export type PlayButtonAction = 'fromStart' | 'fromElement' | 'fromScene' | 'fromTimelineMarker';

export interface TrackPlayScribeAction {
  type: typeof TRACK_PLAY_SCRIBE;
  scribeId: number;
  button: PlayButtonAction;
  sceneCount: number;
  eventTrigger: string;
}

export const trackPlayScribe = (
  scribeId: number,
  button: PlayButtonAction,
  sceneCount: number,
  eventTrigger: string
): TrackPlayScribeAction => ({
  type: TRACK_PLAY_SCRIBE,
  scribeId,
  button,
  sceneCount,
  eventTrigger
});

export interface TrackOpenScribeAction {
  type: typeof TRACK_OPEN_SCRIBE;
  scribeId: number;
}

export const trackOpenScribe = (scribeId: number): TrackOpenScribeAction => ({
  type: TRACK_OPEN_SCRIBE,
  scribeId
});

export interface TrackFreeTransformSelectedAction {
  type: typeof TRACK_FREE_TRANSFORM_SELECTED;
  selected: boolean;
  elementType: ElementType;
  scribeId: number;
}

export const trackFreeTransformSelected = (
  selected: boolean,
  elementType: ElementType,
  scribeId: number
): TrackFreeTransformSelectedAction => ({
  type: TRACK_FREE_TRANSFORM_SELECTED,
  selected,
  elementType,
  scribeId
});

export interface TrackFlipElementAction {
  type: typeof TRACK_FLIP_ELEMENT;
  direction: DirectionType;
  elementType: ElementType;
  scribeId: number;
}

export const trackFlipElement = (
  direction: DirectionType,
  elementType: ElementType,
  scribeId: number
): TrackFlipElementAction => ({
  type: TRACK_FLIP_ELEMENT,
  direction,
  elementType,
  scribeId
});

export interface TrackSelectFontAction {
  type: typeof TRACK_SELECT_FONT;
  fontName: string;
  scribeId: number;
}

export const trackSelectFont = (fontName: string, scribeId: number): TrackSelectFontAction => ({
  type: TRACK_SELECT_FONT,
  fontName,
  scribeId
});

export interface TrackAlignTextAction {
  type: typeof TRACK_ALIGN_TEXT;
  alignment: TextAlignValue;
  scribeId: number;
}

export const trackAlignText = (alignment: TextAlignValue, scribeId: number): TrackAlignTextAction => ({
  type: TRACK_ALIGN_TEXT,
  alignment,
  scribeId
});

export interface TrackBoldTextAction {
  type: typeof TRACK_BOLD_TEXT;
  selected: boolean;
  scribeId: number;
  eventTrigger?: string;
}

export const trackBoldText = (selected: boolean, scribeId: number, eventTrigger?: string): TrackBoldTextAction => ({
  type: TRACK_BOLD_TEXT,
  selected,
  scribeId,
  eventTrigger
});

export interface TrackItalicTextAction {
  type: typeof TRACK_ITALIC_TEXT;
  selected: boolean;
  scribeId: number;
  eventTrigger?: string;
}

export const trackItalicText = (selected: boolean, scribeId: number, eventTrigger?: string): TrackItalicTextAction => ({
  type: TRACK_ITALIC_TEXT,
  selected,
  scribeId,
  eventTrigger
});

export interface TrackChangeElementColorAction {
  type: typeof TRACK_CHANGE_ELEMENT_COLOR;
  elementType: ElementType;
  colorType: ColorType;
  gradientDirection?: DirectionType;
  colorTab: ColorTab;
  scribeId: number;
  colorLayer?: ColorLayer;
  imageName?: string;
}

type TrackChangeElementColorProperties = Omit<TrackChangeElementColorAction, 'type'>;

export const trackChangeElementColor = ({
  elementType,
  colorType,
  gradientDirection,
  colorTab,
  scribeId,
  colorLayer,
  imageName
}: TrackChangeElementColorProperties): TrackChangeElementColorAction => ({
  type: TRACK_CHANGE_ELEMENT_COLOR,
  elementType,
  colorType,
  gradientDirection,
  colorTab,
  scribeId,
  colorLayer,
  imageName
});

export const trackDownloadProgressHidden = () => ({
  type: TRACK_DOWNLOAD_PROGRESS_HIDDEN
});

export interface TrackFullScreenEnteredAction {
  type: typeof TRACK_FULLSCREEN_ENTERED;
  scribeId: number;
  eventTrigger: string;
}
export const trackFullscreenEntered = ({
  scribeId,
  eventTrigger
}: Omit<TrackFullScreenEnteredAction, 'type'>): TrackFullScreenEnteredAction => ({
  type: TRACK_FULLSCREEN_ENTERED,
  scribeId,
  eventTrigger
});

interface TrackSelectAllAction {
  type: typeof TRACK_SELECT_ALL;
  scribeId: number;
  eventTrigger: string;
  hasScenesSelected: boolean;
}

export const trackSelectAll = ({
  scribeId,
  eventTrigger,
  hasScenesSelected
}: Omit<TrackSelectAllAction, 'type'>): TrackSelectAllAction => ({
  type: TRACK_SELECT_ALL,
  scribeId,
  eventTrigger,
  hasScenesSelected
});

export interface TrackShareProjectAction {
  type: typeof TRACK_SHARE_PROJECT;
  scribeId: number;
  trigger: string;
}
export const trackShareProject = ({
  scribeId,
  trigger
}: Omit<TrackShareProjectAction, 'type'>): TrackShareProjectAction => ({
  type: TRACK_SHARE_PROJECT,
  scribeId,
  trigger
});

export interface TrackPreviewLinkCopyAction {
  type: typeof TRACK_PREVIEW_LINK_COPY;
  scribeId: number;
}
export const trackPreviewLinkCopy = ({
  scribeId
}: Omit<TrackPreviewLinkCopyAction, 'type'>): TrackPreviewLinkCopyAction => ({
  type: TRACK_PREVIEW_LINK_COPY,
  scribeId
});

export interface TrackImageReplaceModalAction {
  type: typeof TRACK_IMAGE_REPLACE_MODAL;
  scribeId: number;
  eventTrigger: string;
}

export const trackImageReplaceModal = ({
  scribeId,
  eventTrigger
}: {
  scribeId: number;
  eventTrigger: string;
}): TrackImageReplaceModalAction => ({
  type: TRACK_IMAGE_REPLACE_MODAL,
  scribeId,
  eventTrigger
});

interface TrackImageReplaceAction {
  type: typeof TRACK_IMAGE_REPLACE;
  scribeId: number;
  filename: string;
  provider: string;
  sourceType: VSLibrarySourceType;
  imageType: string;
  selectedLibrary?: string;
  recolorAvailable?: boolean;
  imageSize?: string | number;
  imageId?: string | number;
  temporaryAssetId?: string | number;
}

export const trackImageReplace = ({
  scribeId,
  filename,
  imageId,
  provider,
  sourceType,
  imageType,
  selectedLibrary,
  recolorAvailable,
  imageSize,
  temporaryAssetId
}: Omit<TrackImageReplaceAction, 'type'>): TrackImageReplaceAction => ({
  type: TRACK_IMAGE_REPLACE,
  scribeId,
  filename,
  imageId,
  provider,
  sourceType,
  imageType,
  selectedLibrary,
  recolorAvailable,
  imageSize,
  temporaryAssetId
});
interface TrackSetActiveElementsVisibilityAction {
  type: typeof TRACK_SET_ACTIVE_ELEMENTS_VISIBILITY;
  scribeId: number;
  elementIds: Array<string>;
  eventTrigger: HideEventTrigger;
  eventName: string;
}

export const trackSetActiveElementsVisibility = ({
  scribeId,
  elementIds,
  eventTrigger,
  eventName
}: Omit<TrackSetActiveElementsVisibilityAction, 'type'>): TrackSetActiveElementsVisibilityAction => ({
  type: TRACK_SET_ACTIVE_ELEMENTS_VISIBILITY,
  scribeId,
  elementIds,
  eventTrigger,
  eventName
});

export const trackSearchByProjectTitle = (): { type: typeof TRACK_SEARCH_BY_PROJECT_TITLE } => ({
  type: TRACK_SEARCH_BY_PROJECT_TITLE
});

export interface TrackCreateNewProjectAction {
  type: typeof TRACK_CREATE_NEW_PROJECT;
  eventTrigger: string;
}

export const trackCreateNewProject = (eventTrigger: string): TrackCreateNewProjectAction => ({
  type: TRACK_CREATE_NEW_PROJECT,
  eventTrigger
});

export const trackCameraWarningModal = (scribeId: number) => ({
  type: TRACK_CAMERA_WARNING_MODAL,
  scribeId: scribeId
});

type OpenInitialActionInModalEventTrigger = 'LHP Text Button' | 'Your Files Button';
export interface TrackOpenRecordAudioModalAction {
  type: typeof TRACK_OPEN_RECORD_AUDIO_MODAL;
  eventTrigger: OpenInitialActionInModalEventTrigger;
}
export const trackOpenRecordAudioModal = (
  eventTrigger: OpenInitialActionInModalEventTrigger
): TrackOpenRecordAudioModalAction => ({
  type: TRACK_OPEN_RECORD_AUDIO_MODAL,
  eventTrigger
});

export interface TrackOpenUploadAudioModalAction {
  type: typeof TRACK_OPEN_UPLOAD_AUDIO_MODAL;
  eventTrigger: OpenInitialActionInModalEventTrigger;
}
export const trackOpenUploadAudioModal = (
  eventTrigger: OpenInitialActionInModalEventTrigger
): TrackOpenUploadAudioModalAction => ({
  type: TRACK_OPEN_UPLOAD_AUDIO_MODAL,
  eventTrigger
});

export type PreviewAudioEventTrigger = 'Audio Library' | 'Your Files' | 'Right Hand Panel';
export interface TrackPreviewAudioAction {
  type: typeof TRACK_PREVIEW_AUDIO;
  eventTrigger: PreviewAudioEventTrigger;
  trackName?: string;
}
export const trackPreviewAudio = (eventTrigger: PreviewAudioEventTrigger, trackName?: string) => ({
  type: TRACK_PREVIEW_AUDIO,
  eventTrigger,
  trackName
});

type AudioSearchTrigger = 'Your Files' | 'Audio Library';
type SearchEventProperties = {
  term: string;
};
export type AudioLibrarySearchEventProperties = SearchEventProperties & {
  genres?: string[];
  tempos?: string[];
  scribeId?: string;
  numberOfResults?: number;
};
export type TrackSearchAudioFilesAction = {
  type: typeof TRACK_SEARCH_AUDIO_FILES;
  eventTrigger: AudioSearchTrigger;
} & AudioLibrarySearchEventProperties;

export const trackSearchAudioFiles = (
  eventTrigger: AudioSearchTrigger,
  eventProperties: AudioLibrarySearchEventProperties
): TrackSearchAudioFilesAction => ({
  type: TRACK_SEARCH_AUDIO_FILES,
  eventTrigger,
  ...eventProperties
});

export type AudioLibarySelectFilterEventProperties = {
  scribeId: string;
  genres?: string[];
  tempos?: string[];
};

export type TrackSelectFilterAudioFilesAction = {
  type: typeof TRACK_SELECT_FILTER_AUDIO_FILES;
} & AudioLibarySelectFilterEventProperties;

export const trackSelectFilterAudioFiles = (
  eventProperties: AudioLibarySelectFilterEventProperties
): TrackSelectFilterAudioFilesAction => ({
  type: TRACK_SELECT_FILTER_AUDIO_FILES,
  ...eventProperties
});

export interface TrackFilterByCategoryAction {
  type: typeof TRACK_FILTER_TEMPLATES_BY_CATEGORY;
  categoryTitle?: string;
  eventTrigger?: string;
}

export const trackFilterTemplatesByCategory = (
  categoryTitle?: string,
  eventTrigger?: string
): TrackFilterByCategoryAction => ({
  type: TRACK_FILTER_TEMPLATES_BY_CATEGORY,
  categoryTitle,
  eventTrigger
});

export enum UpgradeSubscriptionClickedEventTrigger {
  UPLOAD_CUSTOM_FONT = 'Upload Custom Font',
  DOWNLOAD_SUCCESS_BANNER = 'Download Success Banner',
  CANVAS_NAV = 'Canvas Nav',
  HOME_BANNER = 'Home Banner',
  NOUN_PROJECT = 'Noun Project',
  DOWNLOAD_LIMIT = 'Download Limit',
  OVER_PROJECT_LIMIT = 'Over Project Limit',
  OVER_DURATION_LIMIT = 'Download Duration',
  EDITOR_BANNER = 'Editor Banner',
  ELEMENT_LIMIT = 'Element Limit',
  HOME_NAV = 'Home Nav',
  CREATE_NEW_SCRIBE = 'Create New Scribe',
  PREMIUM_TEMPLATE = 'Premium Template',
  PREVIEW_VIEW = 'Preview View',
  EDIT_TEMPLATE = 'Edit Template',
  SCRIBE_TILE_MENU = 'Scribe Tile Menu',
  UPGRADE_WARNING_MODAL = 'Upgrade Warning Modal',
  TEMPLATE_PREVIEW_MODAL = 'Template Preview Modal',
  CREATE_PREVIEW_LINK = 'Create Preview Link',
  PREMIUM_BOUNDING_BOX_INDICATOR = 'Premium bounding box',
  PREMIUM_THUMBNAIL_INDICATOR = 'Premium icon in library',
  IMAGE_GENERATION_LIMIT = 'Image Generation Limit',
  SCRIPT_GENERATION_LIMIT = 'Script Generation Limit',
  VOICE_GENERATION_LIMIT = 'Voice Generation Limit',
  SHARE_YOUR_VIDEO_MODAL = 'Share your video modal',
  DEFAULT_SETTINGS_MODAL = 'Default Settings Modal',
  BRAND_KIT = 'Brand Kit',
  LEGACY_PROJECT_CONVERSION = 'Legacy Project Conversion'
}

export interface TrackUpgradeSubscriptionButtonClickedAction {
  type: typeof TRACK_UPGRADE_SUBSCRIPTION_BUTTON_CLICKED;
  tier: AccountType;
  term: AccountTerm;
  eventTrigger: UpgradeSubscriptionClickedEventTrigger;
  extraEventProps?: UpgradeButtonClickExtraEventProps;
}

export const trackUpgradeSubscriptionButtonClicked = (
  tier: AccountType,
  term: AccountTerm,
  eventTrigger: UpgradeSubscriptionClickedEventTrigger,
  extraEventProps?: UpgradeButtonClickExtraEventProps
): TrackUpgradeSubscriptionButtonClickedAction => ({
  type: TRACK_UPGRADE_SUBSCRIPTION_BUTTON_CLICKED,
  tier,
  term,
  eventTrigger,
  extraEventProps
});

export interface TrackPurchaseSubscriptionButtonClickedAction {
  type: typeof TRACK_PURCHASE_SUBSCRIPTION_BUTTON_CLICKED;
  tier: AccountType;
  term: AccountTerm;
  eventTrigger: UpgradeSubscriptionClickedEventTrigger;
  extraEventProps?: UpgradeButtonClickExtraEventProps;
}

export const trackPurchaseSubscriptionButtonClicked = (
  tier: AccountType,
  term: AccountTerm,
  eventTrigger: UpgradeSubscriptionClickedEventTrigger,
  extraEventProps?: UpgradeButtonClickExtraEventProps
): TrackPurchaseSubscriptionButtonClickedAction => ({
  type: TRACK_PURCHASE_SUBSCRIPTION_BUTTON_CLICKED,
  tier,
  term,
  eventTrigger,
  extraEventProps
});

interface TrackNoAccessFeatureModalDisplayedAction {
  type: typeof TRACK_NO_ACCESS_FEATURE_MODAL_DISPLAYED;
  scribeId: number;
  triggerSource: UpgradeSubscriptionClickedEventTrigger;
}

export const trackNoAccessFeatureModalDisplayed = (
  scribeId: number,
  triggerSource: UpgradeSubscriptionClickedEventTrigger
): TrackNoAccessFeatureModalDisplayedAction => ({
  type: TRACK_NO_ACCESS_FEATURE_MODAL_DISPLAYED,
  scribeId,
  triggerSource
});

export const trackDownloadBlockedByPremiumContent = (scribeId: number) => ({
  type: TRACK_DOWNLOAD_BLOCKED_BY_PREMIUM_CONTENT,
  scribeId
});

export const TRACK_PROJECT_STYLE_SELECTED = 'TRACK_PROJECT_STYLE_SELECTED';
export const TRACK_PROJECT_STYLE_CHANGED = 'TRACK_PROJECT_STYLE_CHANGED';
export const TRACK_PROJECT_STYLE_REMOVED = 'TRACK_PROJECT_STYLE_REMOVED';

export const TRACK_DOWNLOAD_DIALOG_SHOWN = 'TRACK_DOWNLOAD_DIALOG_SHOWN';
export const TRACK_DOWNLOAD_DIALOG_GO_TO_WORKSPACE = 'TRACK_DOWNLOAD_DIALOG_GO_TO_WORKSPACE';
export const TRACK_DOWNLOAD_DIALOG_CONTINUE_EDITING = 'TRACK_DOWNLOAD_DIALOG_CONTINUE_EDITING';

export const trackDownloadDialogShown = () => ({
  type: TRACK_DOWNLOAD_DIALOG_SHOWN
});

export const trackDownloadDialogGoToWorkspace = () => ({
  type: TRACK_DOWNLOAD_DIALOG_GO_TO_WORKSPACE
});

export const trackDownloadDialogContinueEditing = () => ({
  type: TRACK_DOWNLOAD_DIALOG_CONTINUE_EDITING
});

export interface TrackProjectStyleSelectedAction {
  type: typeof TRACK_PROJECT_STYLE_SELECTED;
  styleName: string;
}
export const trackProjectStyleSelected = (styleName: string): TrackProjectStyleSelectedAction => ({
  type: TRACK_PROJECT_STYLE_SELECTED,
  styleName
});

export interface TrackProjectStyleChangedAction {
  type: typeof TRACK_PROJECT_STYLE_CHANGED;
  previousStyle: string;
  newStyle: string;
}
export const trackProjectStyleChanged = (previousStyle: string, newStyle: string): TrackProjectStyleChangedAction => ({
  type: TRACK_PROJECT_STYLE_CHANGED,
  previousStyle,
  newStyle
});

export interface TrackProjectStyleRemovedAction {
  type: typeof TRACK_PROJECT_STYLE_REMOVED;
}
export const trackProjectStyleRemoved = (): TrackProjectStyleRemovedAction => ({
  type: TRACK_PROJECT_STYLE_REMOVED
});

export const trackWordSelectedInTranscriptPanel = () => ({
  type: TRACK_WORD_SELECTED_IN_TRANSCRIPT_PANEL
});

export const trackClickAssetsTab = () => ({
  type: TRACK_CLICK_ASSETS_TAB as typeof TRACK_CLICK_ASSETS_TAB
});

export const trackClickAssetsImagesTab = () => ({
  type: TRACK_CLICK_ASSETS_IMAGES_TAB as typeof TRACK_CLICK_ASSETS_IMAGES_TAB
});

export const trackRenameImageAsset = () => ({
  type: TRACK_RENAME_IMAGE_ASSET as typeof TRACK_RENAME_IMAGE_ASSET
});

export const trackDeleteImageAsset = () => ({
  type: TRACK_DELETE_IMAGE_ASSET as typeof TRACK_DELETE_IMAGE_ASSET
});

export const trackUploadImageFromHomepage = () => ({
  type: TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE as typeof TRACK_UPLOAD_IMAGE_FROM_HOMEPAGE
});
